import type { ClientReportDto, CommissionReportDto, GetClientReportDto, GetCommissionPagedReportDto, GetWinesSalesReportDto, WineSalesReportDto } from './dto/models';
import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { EnumDto } from '../enums/models';
import type { SommelierDto } from '../sommeliers/models';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  apiName = 'Default';
  

  generateCommissionExcel = (input: GetCommissionPagedReportDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'POST',
      responseType: 'blob',
      url: '/api/app/report/generate-commission-excel',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  generateWineSalesExcel = (input: GetWinesSalesReportDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'POST',
      responseType: 'blob',
      url: '/api/app/report/generate-wine-sales-excel',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  getClientReport = (input: GetClientReportDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<ClientReportDto>>({
      method: 'GET',
      url: '/api/app/report/client-report',
      params: { from: input.from, to: input.to, keyword: input.keyword, isGrouped: input.isGrouped, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getCommissionReportPaged = (input: GetCommissionPagedReportDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<CommissionReportDto>>({
      method: 'GET',
      url: '/api/app/report/commission-report-paged',
      params: { from: input.from, to: input.to, status: input.status, sommelierId: input.sommelierId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getOrderStatuses = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, EnumDto[]>({
      method: 'GET',
      url: '/api/app/report/order-statuses',
    },
    { apiName: this.apiName,...config });
  

  getSommeliers = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, SommelierDto[]>({
      method: 'GET',
      url: '/api/app/report/sommeliers',
    },
    { apiName: this.apiName,...config });
  

  getWineSalesReport = (input: GetWinesSalesReportDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<WineSalesReportDto>>({
      method: 'GET',
      url: '/api/app/report/wine-sales-report',
      params: { from: input.from, to: input.to, keyword: input.keyword, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
